import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
/**
 * The picker itself is one dynamic import away.
 *
 * `react-color` brings both `lodash` and `lodash-es` with it — three hundred
 * and eighty kilobytes between them — and reaching it through this package's
 * barrel put all of it in the first download of every session, for a control
 * that appears in the theme editor and in the chart's plugin settings.
 *
 * `ColorPickerTrigger` stays eager: it is the swatch rendered while the picker
 * is closed, and it is a button with a background.
 */
const Sketch = React.lazy(async () => {
    const module_ = await import('./color-picker-sketch');
    return { default: module_.ColorPicker };
});
export const ColorPicker = (props) => (_jsx(React.Suspense, { fallback: undefined, children: _jsx(Sketch, { ...props }) }));
export const ColorPickerTrigger = ({ color, className, onClick, }) => {
    return (_jsx(ColorPickerTriggerRoot, { style: { background: color }, onClick: onClick, className: className, children: _jsx(ColorPickerTriggerInner, {}) }));
};
const ColorPickerTriggerRoot = styled.button `
  all: unset;
  cursor: pointer;
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: 1px solid var(--backgroundA-2);
`;
const ColorPickerTriggerInner = styled.div `
  width: 100%;
  height: 100%;
  min-height: 0;
  background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAADFJREFUOE9jZGBgEGHAD97gk2YcNYBhmIQBgWSAP52AwoAQwJvQRg1gACckQoC2gQgAIF8IscwEtKYAAAAASUVORK5CYII=')
    left center;
`;
//# sourceMappingURL=color-picker.js.map